import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import MaskedInput from "components/shared/InputMask/InputMask";

import styles from "./style.module.scss";

export const Input = React.forwardRef(
    (
        {
            type = "text",
            placeholder,
            onInput,
            error,
            defaultError,
            children,
            name,
            maxLength,
            min,
            max,
            label,
            icon,
            value = "",
            align,
            labelFiled,
            disabled,
            readonly,
            style,
            className,
            horizontalError,
            inputLabelStyle = { left: "4px" },
            autocomplete = "off",
        },
        ref,
    ) => {
        const [valueInput, setValueInput] = useState();

        useEffect(() => {
            setValueInput(value);
        }, [value]);
        const render = () => {
            return (
                <div className={classNames(styles.Input, labelFiled && styles.Input__withLabelFields, className)}>
                    {labelFiled && <label className={styles.Input__labelFiled}>{labelFiled}</label>}
                    {label && <label className={styles.Input__label}>{label}</label>}
                    {icon && <i className={icon} />}
                    <input
                        type={type}
                        placeholder={placeholder}
                        onChange={onInput}
                        onInput={(e) => setValueInput(e.target.value)}
                        name={name}
                        disabled={disabled}
                        readonly={readonly}
                        maxLength={maxLength}
                        value={value ? value : valueInput}
                        min={min}
                        max={max}
                        style={{ textAlign: align, direction: align && "ltr", ...style }}
                        autocomplete={autocomplete}
                        ref={ref}
                    />
                    <span className={styles.Input_icon} style={inputLabelStyle}>
                        {children}
                    </span>
                    {error && <span className={styles.error}>{error}</span>}
                    {defaultError && (
                        <span className={classNames(styles.error, horizontalError && "horizontalError")}>
                            این فیلد الزامی است
                        </span>
                    )}
                </div>
            );
        };

        return render();
    },
);
export const InputMask = ({
    type = "text",
    placeholder,
    onInput,
    error,
    defaultError,
    children,
    name,
    maxLength,
    min,
    max,
    label,
    icon,
    value = "",
    mask,
    size,
    align,
    labelFiled,
    disabled,
    readonly,
    style,
    className,
    horizontalError,
    inputLabelStyle = { left: "4px" },
}) => {
    const [valueInput, setValueInput] = useState();

    useEffect(() => {
        setValueInput(value);
    }, [value]);

    return (
        <div className={classNames(styles.Input, labelFiled && styles.Input__withLabelFields, className)}>
            {labelFiled && <label className={styles.Input__labelFiled}>{labelFiled}</label>}
            {label && <label className={styles.Input__label}>{label}</label>}
            {icon && <i className={icon} />}
            <MaskedInput
                mask={mask}
                size={size}
                type={type}
                placeholder={placeholder}
                onChange={onInput}
                onInput={(e) => setValueInput(e.target.rawValue)}
                name={name}
                disabled={disabled}
                readonly={readonly}
                maxLength={maxLength}
                value={value ? value : valueInput}
                min={min}
                max={max}
                autocomplete="no"
                style={{ textAlign: align, direction: align && "ltr", ...style }}
            />
            <span className={styles.Input_icon} style={inputLabelStyle}>
                {children}
            </span>
            {error && <span className={styles.error}>{error}</span>}
            {defaultError && (
                <span className={classNames(styles.error, horizontalError && "horizontalError")}>
                    این فیلد الزامی است
                </span>
            )}
        </div>
    );
};

export const Textarea = ({
    placeholder,
    error,
    onInput,
    value,
    name,
    disabled,
    label,
    labelFiled,
    className,
    children,
    icon,
    autocomplete = "off",
}) => {
    return (
        <div className={classNames(styles.textarea, labelFiled && styles.textarea__withLabelFields, className)}>
            {labelFiled && <label className={styles.textarea__labelFiled}>{labelFiled}</label>}
            {label && <label className={styles.textarea__label}>{label}</label>}
            {icon && <i className={icon} />}
            <textarea
                name={name}
                disabled={disabled}
                placeholder={placeholder}
                onChange={onInput}
                value={value}
                autocomplete={autocomplete}
            />
            <span className={styles.textarea_icon}>{children}</span>
            {error && <error className={styles.error}>{error}</error>}
        </div>
    );
};

export const DoubleInput = ({
    typeFirst = "text",
    typeSecond = "text",
    valueFirst,
    valueSecond,
    placeholderFirst,
    placeholderSecond,
    onInputFirst,
    onInputSecond,
    errorFirst,
    errorSecond,
    nameFirst,
    nameSecond,
    maxLengthFirst,
    maxLengthSecond,
    labelFirst,
    labelSecond,
    iconFirst,
    iconSecond,
    width,
    defaultError,
    alignFirst = "right",
    alignSecond = "right",
    className,
    horizontalError,
}) => {
    return (
        <div className={styles.doubleInput + " " + className} style={{ width: width && width }}>
            <Input
                type={typeFirst}
                onInput={onInputFirst}
                label={labelFirst}
                icon={iconFirst}
                name={nameFirst}
                maxLength={maxLengthFirst}
                placeholder={placeholderFirst}
                error={errorFirst}
                defaultError={defaultError}
                value={valueFirst}
                align={alignFirst}
                horizontalError
            />
            <Input
                type={typeSecond}
                onInput={onInputSecond}
                label={labelSecond}
                icon={iconSecond}
                name={nameSecond}
                maxLength={maxLengthSecond}
                placeholder={placeholderSecond}
                error={errorSecond}
                value={valueSecond}
                align={alignSecond}
                horizontalError
            />
        </div>
    );
};

export const Checkbox = ({ label, name, checked, onChange, disabled }) => {
    return (
        <div className={styles.checkbox}>
            <label className={styles.checkbox__container}>
                <input type="checkbox" checked={checked} onChange={onChange} name={name} disabled={disabled} />
                <span className={styles.checkbox__checkmark}></span>
                {label}
            </label>
        </div>
    );
};

export const Radio = ({ label, name, checked, onChange, value, disabled }) => {
    return (
        <div className={styles.radio}>
            <label className={styles.radio__container}>
                <input
                    value={value}
                    type="radio"
                    checked={checked}
                    onChange={onChange}
                    name={name}
                    disabled={disabled}
                />
                <span className={styles.radio__checkmark}></span>
                {label}
            </label>
        </div>
    );
};

export const ToggleSwitch = ({
    id,
    name,
    value,
    onChange,
    optionLabels = [true, false],
    disabled,
    isBoolean = false,
    width = "100px",
}) => {
    const handleKeyPress = (e) => {
        if (e.keyCode !== 32) return;

        e.preventDefault();
        //   onChange(!checked);
    };

    return (
        <div className={styles.switch} style={{ width: width }}>
            <input
                type="checkbox"
                name={name}
                className={styles.switch__checkbox}
                id={id}
                checked={value === optionLabels[0]}
                onChange={(e) => onChange(e.target.checked ? optionLabels[0] : optionLabels[1])}
                disabled={disabled}
            />
            {name ? (
                <label
                    className={styles.switch__label}
                    tabIndex={disabled ? -1 : 1}
                    onKeyDown={(e) => handleKeyPress(e)}
                    htmlFor={id}
                >
                    <span
                        className={classNames(
                            styles.switch__inner,
                            disabled && styles.switch__disabled,
                            isBoolean && styles.switch__isBoolean,
                        )}
                        data-yes={isBoolean ? " " : optionLabels[0]}
                        data-no={isBoolean ? " " : optionLabels[1]}
                        tabIndex={-1}
                    />

                    <span
                        className={
                            (disabled ? styles.switch__switch + " " + styles.switch__disabled : styles.switch__switch) +
                            (value === optionLabels[0] ? " first-active" : " second-active")
                        }
                        tabIndex={-1}
                    />
                </label>
            ) : null}
        </div>
    );
};

export const InputNumber = ({
    onInput,
    error,
    defaultError,
    name,
    min,
    max,
    label,
    value,
    labelFiled,
    disabled,
    readonly,
    horizontalError,
    style,
    inputLabelStyle = { left: "35px" },
    children,
    className,
    autocomplete = "off",
}) => {
    const [valueInput, setValueInput] = useState();

    useEffect(() => {
        setValueInput(value);
    }, [value]);

    return (
        <div className={classNames(styles.InputNumber, labelFiled && styles.InputNumber__withLabelFields, className)}>
            {labelFiled && <label className={styles.InputNumber__labelFiled}>{labelFiled}</label>}
            {label && <label className={styles.InputNumber__label}>{label}</label>}
            <i
                className={"icon-chevron-with-circle-down " + styles.InputNumber__btn_up}
                onClick={() => onInput(Number(value) + 1)}
            />
            <input
                type="number"
                min={0}
                pattern="^(([0-9]*)|([0-9]*\.[0-9]*))$"
                inputmode="numeric"
                onChange={(e) => Number(e.target.value) >= 0 && onInput(Number(e.target.value) + 0)}
                onInput={(e) => setValueInput(Number(e.target.value) + 0)}
                name={name}
                disabled={disabled}
                readonly={readonly}
                max={max}
                value={value ? value : valueInput}
                autocomplete={autocomplete}
            />
            <i
                className={"icon-chevron-with-circle-down " + styles.InputNumber__btn_down}
                onClick={() => value > 0 && onInput(Number(value) - 1)}
            />
            <span className={styles.Input_icon} style={inputLabelStyle}>
                {children}
            </span>
            {error && <span className={styles.error}>{error}</span>}
            {defaultError && (
                <span className={classNames(styles.error, horizontalError && "horizontalError")}>
                    این فیلد الزامی است
                </span>
            )}
        </div>
    );
};
